// Node apis ecotec server
// const API_BASE_CRM_URL = 'https://crmxtnapi.azurewebsites.net/';

// const API_BASE_CRM_URL = " https://qacrmext.ibizaccounts.in/";

// Prefix apis
// const API_BASE_CRM_URL = 'https://mycrm.ibizaccounts.com/api/';

// const API_BASE_URL = 'https://shop.ibizaccounts.in/';

// const API_BASE_URL = "https://qaibizapi.perennialdigitals.com/";
// const API_BASE_URL = "http://localhost:3009/";
// const API_BASE_URL = "https://9nbrmgtj-3009.inc1.devtunnels.ms/";
const API_BASE_URL = "https://qaapi.ibizaccounts.com/";

// const API_BASE_URL = "https://shopapi.perennialdigitals.com/";

// const IMAGE_URL_IBIZ = "https://pcuploadfiles.azurewebsites.net/download?path=";
// const IMAGE_URL_IBIZ = "https://files-test.perennialcode.com/";
const IMAGE_URL_IBIZ = "https://files.perennialcode.com/";
// const BASE_API_KEY = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoiYXBwc0BwZXJlbm5pYWxjb2RlLmluIiwibmFtZSI6IkRldmVsb3BlciIsIkFQSV9USU1FIjoxNzA4NjkzMzIwfQ.PoXlVNphTxBluptxrYSko6ENBnyO6Vgw87anIGxv0Y4"

// export { API_BASE_CRM_URL };
export { API_BASE_URL };
export { IMAGE_URL_IBIZ };
